import { render, staticRenderFns } from "./Plan_svg.vue?vue&type=template&id=2e921001&scoped=true"
import script from "./Plan_svg.vue?vue&type=script&lang=js"
export * from "./Plan_svg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e921001",
  null
  
)

export default component.exports